import React from 'react';
import { Button, Flex, Input, Text } from "@chakra-ui/react"
import { TenantFormPropTypes } from "../PayRentPropTypes"
import { Form } from "react-final-form";
import { useRef } from 'react';
import { emailFormButtonProps, payRentMainContainerProps, statesList } from "../constants";
import { FormField } from "../../../components/form";
import { tenantFormConfig } from "../config";
import { localisable } from "../../../generic/localisable";
import { renderStateDropdown } from "../Utils";

export const TenantForm = ({
    FirstName,
    LastName,
    Phone,
    EmailAddress,
    AddressLine1,
    AddressLine2,
    City,
    State,
    ZIP,
    logOffHandler,
    updateTenantFormHandler
}: TenantFormPropTypes.ICombinedTenantFormProps) => {

    const formProps = useRef({});

    const initialValues = {
        FirstName,
        LastName,
        Phone,
        EmailAddress,
        AddressLine1,
        AddressLine2,
        City,
        State,
        ZIP,
    };

    const onSubmit = () => {
        updateTenantFormHandler(formProps.current)
    };

    const handleUndoChanges = (form: any) => {
        form.reset(initialValues);
    };

    const renderButtonSection = (currentFormProps: any) => {
        const { form, dirty } = currentFormProps;

        return (
            <Flex direction={{ base: 'column', sm: 'row' }} gap='16px' justifyContent={{ sm: 'flex-end' }} mt='16px'>
                <Button
                    {...emailFormButtonProps}
                    onClick={() => logOffHandler()}
                    bg='button.blue'
                    minW={{ base: '100%', sm: '204px' }}
                >
                    <Text textStyle='buttonSmall' color='common.white' >{localisable.logOff}</Text>
                </Button>
                <Button
                    {...emailFormButtonProps}
                    onClick={() => handleUndoChanges(form)}
                    bg='button.blue'
                    minW={{ base: '100%', sm: '204px' }}
                >
                    <Text textStyle='buttonSmall' color='common.white' >{localisable.undoChanges}</Text>
                </Button>
                <Button
                    {...emailFormButtonProps}
                    type='submit'
                    bg='button.blue'
                    minW={{ base: '100%', sm: '204px' }}
                    isDisabled={!dirty}
                >
                    <Text textStyle='buttonSmall' color='common.white' >{localisable.updateTenantInformation}</Text>
                </Button>
            </Flex>
        )
    };

    const renderForm = (currentFormProps: any) => {

        const { firstNameProps, lastNameProps, phoneProps, emailProps, addressLine1Props, addressLine2Props, zipCodeProps,
            cityProps, stateProps } = tenantFormConfig() || {};

        return (
            <Flex direction='column' w='100%' padding={{ sm: '0px 96px' }} gap='24px'>
                <Text textStyle='h2' mb='8px'>{localisable.tenantInformation}</Text>
                <Flex direction={{ base: 'column', sm: 'row' }} gap={{ base: '24px', sm: '32px' }}>
                    <FormField {...firstNameProps} {...currentFormProps} >
                        <Input />
                    </FormField>
                    <FormField {...lastNameProps} {...currentFormProps} >
                        <Input />
                    </FormField>
                </Flex>
                <Flex direction={{ base: 'column', sm: 'row' }} gap={{ base: '24px', sm: '32px' }}>
                    <FormField {...phoneProps} {...currentFormProps} >
                        <Input />
                    </FormField>
                    <FormField {...emailProps} {...currentFormProps} >
                        <Input />
                    </FormField>
                </Flex>
                <FormField {...addressLine1Props} {...currentFormProps} >
                    <Input />
                </FormField>
                <FormField {...addressLine2Props} {...currentFormProps} >
                    <Input />
                </FormField>
                <Flex gap={{ base: '24px', sm: '32px' }} direction={{ base: 'column', sm: 'row' }} alignItems={{ sm: 'flex-start' }}>
                    <FormField {...cityProps} {...currentFormProps} >
                        <Input />
                    </FormField>
                    <Flex gap={{ base: '24px', sm: '32px' }}>
                        <FormField {...stateProps} {...currentFormProps}>
                            {renderStateDropdown(statesList, currentFormProps.values.state)}
                        </FormField>
                        <FormField {...zipCodeProps} {...currentFormProps} >
                            <Input />
                        </FormField>
                    </Flex>
                </Flex>
                {renderButtonSection(currentFormProps)}
            </Flex >
        )
    };

    return (
        <Flex direction='column' {...payRentMainContainerProps} gap='24px'>
            <Form
                onSubmit={onSubmit}
                initialValues={initialValues}
                render={(currentFormProps) => {
                    const { handleSubmit, ...restFormProps } = currentFormProps;
                    formProps.current = restFormProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            {renderForm(currentFormProps)}
                        </form>
                    )
                }}
            />
        </Flex>
    )
}